import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import styled from 'styled-components';
import { Row, Col, Container } from 'react-bootstrap';

const OrganizationUnavailable = () => {
  return (
    <Container>
      <Row>
        <Col md="2" xs="2">
          <ExclamationTriangle />
        </Col>
        <Col>Not Available</Col>
      </Row>
    </Container>
  );
};

const ExclamationTriangle = styled(FaExclamationTriangle)`
  font-size: 3rem;
  color: ${(props) => props.theme.palette.alert[0]};
`;

export default OrganizationUnavailable;
